<template>
    <div class="chart-gauge" :class="[`size-${size}`]" :style="style">
        <div class="percentage"></div>
        <div class="mask"></div>
        <span v-if="!noValue && size !== 'xxs'" class="value" :class="`text-${status.variant}`">
            <slot>
                {{value}}<template v-if="unit && size !== 'xs'">{{unit}}</template>
            </slot>
        </span>
    </div>
</template>

<script>
export default {
    name: `chart-gauge`,
    props: {
        value: {type: Number},
        noValue: {type: Boolean},
        unit: {type: String, default: ``},
        size: {type: String, default: `md`}
    },
    computed: {
        style() {
            return {
                "--rotation": `${(this.value / 100) * 180}deg`,
                "--chart-color": `var(${this.status.color})`
            };
        },
        status() {
            if (this.value >= 90) {
                return {
                    color: `--color-primary`,
                    variant: `primary`,
                    glyph: `fa-gauge-max`,
                    title: `Max (must have)|Max (indispensable)`
                };
            } else if (this.value >= 70) {
                return {
                    color: `--color-info`,
                    variant: `info`,
                    glyph: `fa-gauge-high`,
                    title: `High|Élevé`
                };
            } else if (this.value >= 50) {
                return {
                    color: `--color-warning`,
                    variant: `warning`,
                    glyph: `fa-gauge`,
                    title: `Medium|Moyen`
                };
            } else {
                return {
                    color: `--color-danger`,
                    variant: `danger`,
                    glyph: `fa-gauge-min`,
                    title: `Low|Faible`
                };
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.chart-gauge {
    --width: 100px;
    --line-width: 13%;
    --rotation: 86deg;
    --bg-color: #ddd;
    --chart-color: #5cb85c;
    position: relative;
    border-radius: 50%/100% 100% 0 0;
    background-color: var(--chart-color);
    overflow: hidden;
    width: var(--width);

    &:before {
        content: "";
        display: block;
        padding-top: 50%; /* ratio of 2:1*/
    }

    .chart {
        overflow: hidden;
    }

    .mask {
        position: absolute;
        left: var(--line-width);
        right: var(--line-width);
        bottom: 0;
        top: calc(var(--line-width) * 2);
        background-color: #fff;
        border-radius: 50%/100% 100% 0 0;
    }

    .percentage {
        position: absolute;
        top: -1px;
        left: -1px;
        bottom: 0;
        right: -1px;
        background-color: var(--bg-color);
        transform: rotate(var(--rotation));
        transform-origin: bottom center;
        transition-duration: 600ms;
    }

    .value {
        position: absolute;
        bottom: 0%;
        left: 0;
        width: 100%;
        text-align: center;
        font-size: 15pt;
    }

    .min {
        position: absolute;
        bottom: 0;
        left: 5%;
    }

    .max {
        position: absolute;
        bottom: 0;
        right: 5%;
    }

    &.size-xxs {
        --width: 20px;

        .value {
            display: none;
        }
    }

    &.size-xs {
        --width: 30px;
        --line-width: 13%;

        .value {
            font-size: 8pt;
            font-weight: 700;
            margin-bottom: -3px;
        }
    }
}

</style>
